var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFacebook({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 8.4 16",
    overflow: "visible",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Facebook",
    transform: "translate(1446 570)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    fillRule: "evenodd",
    d: "M-1440.6-554v-7.3h2.5l0.4-2.8h-2.8v-1.8c0-0.8,0.3-1.4,1.4-1.4h1.5v-2.6 c-0.4,0-1.2-0.1-2.2-0.1c-1.9-0.1-3.5,1.3-3.7,3.2c0,0.2,0,0.4,0,0.5v2.1h-2.5v2.8h2.5v7.3H-1440.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFacebook);
export default __webpack_public_path__ + "static/media/icon_facebook.770bb0e684172d976efd331496738804.svg";
export { ForwardRef as ReactComponent };